import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetNotice } from "./service";

export const useGetNotice = (options) => {
  return useQuery([queryKey.ANNOUNCE], () => apiGetNotice().then((res) => res.data.data), {
    ...options,
  });
};
